/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The role of the person in the family.
 */
export type PersonFamilyRole = {
    /**
     * The ID of an existing family.
     */
    id?: number | null;
    /**
     * Link to an image.
     */
    photo?: string;
    role?: PersonFamilyRole.role;
};

export namespace PersonFamilyRole {

    export enum role {
        UNASSIGNED = 'Unassigned',
        CHILD = 'Child',
        ADULT = 'Adult',
        HEAD_OF_HOUSEHOLD = 'Head of Household',
        SPOUSE = 'Spouse',
    }


}

